import { api } from './client.js';

export const alertsApi = {
  list: () => api('/alerts'),
  trigger: () => api('/alerts/trigger', { method: 'POST' }),
};
